/**
 * <h4>Recommendation filtering</h4>
 *
 * You can add to placement filters.
 * It allows you to filter products into a specific category
 * It allows you to filter products into a specific price between min and max price
 * Recommendations in the context of a product should contain the id of the product for which the
 * recommendation will be generated. For example, to get a list of products similar to product A,
 * provide the product ID of A.
 * @packageDocumentation
 */
export {CategoryFilter} from './CategoryFilter'
export {ProductFilter} from './ProductFilter'
export {MaxPriceFilter} from  './MaxPriceFilter'
export {MinPriceFilter} from  './MinPriceFilter'
export {Filter} from './Filter'
